var _rect, _path, _g, _rect2, _rect3, _rect4, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullWidthImageListings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 111,
    viewBox: "0 0 156 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 110,
    transform: "translate(0 0.562378)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7461_24312)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7461_24312",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 26,
    width: 136,
    height: 59
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.455 26.4111H12.5455C11.4158 26.4111 10.5 27.1805 10.5 28.1296V83.1199C10.5 84.0689 11.4158 84.8383 12.5455 84.8383H143.455C144.584 84.8383 145.5 84.0689 145.5 83.1199V28.1296C145.5 27.1805 144.584 26.4111 143.455 26.4111Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7461_24312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.455 26.4111H12.5455C11.4158 26.4111 10.5 27.1805 10.5 28.1296V83.1199C10.5 84.0689 11.4158 84.8383 12.5455 84.8383H143.455C144.584 84.8383 145.5 84.0689 145.5 83.1199V28.1296C145.5 27.1805 144.584 26.4111 143.455 26.4111Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M122.185 63.815C127.685 63.8731 147.604 75.0404 154.144 76.32C160.685 77.5996 158.604 84.986 158.604 84.986H53.2136C53.2136 84.986 90.2263 67.9446 94.5375 68.8171C98.8479 69.6895 98.2534 71.6669 101.969 71.7251C105.686 71.7833 116.686 63.7569 122.185 63.815Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6635 55.7927C27.1313 55.8728 14.3392 71.2716 10.1388 73.0361C5.93841 74.8006 7.27487 84.9861 7.27487 84.9861H74.9585C74.9585 84.9861 51.1881 61.4871 48.4196 62.6902C45.6512 63.8932 46.0332 66.6199 43.6466 66.7002C41.2599 66.7804 34.1956 55.7126 30.6635 55.7927Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.686 69.514C120.154 69.5565 107.362 77.7177 103.162 78.6528C98.9609 79.588 100.297 84.9861 100.297 84.9861H167.981C167.981 84.9861 144.21 72.532 141.442 73.1696C138.674 73.8072 139.056 75.2523 136.67 75.2948C134.283 75.3374 127.218 69.4716 123.686 69.514Z",
    fill: "#D9D9D9"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 60.8813,
    y: 44.637,
    width: 34.202,
    height: 7.2085,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 58.9502,
    y: 55.3914,
    width: 38.0641,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 56.5,
    y: 59.6096,
    width: 42.9645,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 64.5469,
    y: 63.8279,
    width: 26.8707,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7461_24312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 59,
    fill: "white",
    transform: "translate(10.5 26.1248)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullWidthImageListings);
export default __webpack_public_path__ + "static/media/full-width-image-listings.9a4609500ae21076c2f1c31a229759c9.svg";
export { ForwardRef as ReactComponent };